export function gatherRequestReturn({ isError, response, status = 0 }) {
	return {
		isError,
		response,
		status,
	};
}
